module.exports = __webpack_public_path__ + "static/img/ewm.2d579194.jpg";